import React, { useEffect } from 'react';
import { TextFieldLayoutItem } from 'models/InputLayoutItem';
import { MultiFormCardHeader } from 'components/MultiFormCardHeader';
import * as yup from 'yup';
import { CreateFormLayout } from 'components/create-form/CreateFormLayout';
import { FORM, LAYOUT_ITEM, PORTABILITY_FORM_DATA_KEY_STORAGE } from 'constants/FormConstants';
import { StorageServiceImpl } from 'services/storage-service/StorageServiceImpl';
import { RutValidator } from 'utils/RutValidator';
import { DateStringValidator } from 'utils/DateValidator';
import { DATA_LAYERS, DATA_LAYER_PAGE } from 'constants/DataLayers';
import TagManager from 'react-gtm-module';
//import { SerialNumberValidator } from 'utils/SerialNumberValidator';
//import { LoadingModal } from 'components/response/LoadingModal';
import { IDENTITY_STORAGE } from 'constants/IdentityStorage';
import { InfoSerialNumber } from 'components/drop-text/InfoSerialNumber';

const storageService = new StorageServiceImpl();

export const PortabilidadPaso3 = () => {
	const nationalId = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.NATIONAL_ID,
		sessionStorage
	);

	const dateOfEmployment = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.DATE_OF_EMPLOYMENT,
		sessionStorage
	);
	const salary = storageService.getFromStoreObject(
		PORTABILITY_FORM_DATA_KEY_STORAGE,
		FORM.SALARY,
		sessionStorage
	);

	//const [showLoading, setshowLoading] = useState<boolean>(false);
	//const [localSerialNumber, setSerialNumber] = useState<string>('');
	//const [serialNumberIsValid, setSerialNumberIsValid] = useState<boolean>(false);
	//const [localRut, setLocalRut] = useState<string>('');

	const fields: TextFieldLayoutItem[] = [
		{
			label: 'Rut',
			defaultValue: nationalId ? nationalId : '',
			name: FORM.NATIONAL_ID,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: 12345678-9',
			mask: 'rut',
			validation: yup
				.string()
				.required('Campo Requerido')
				.min(8, 'ingrese un rut válido')
				.test('rut-valid', 'ingrese un rut válido', (value) => {
					if (value !== undefined && RutValidator(value)) {
						//setLocalRut(value.replaceAll('.', ''));
						return true;
					} else {
						//setLocalRut('');
						return false;
					}
				}),
		},
		{
			label: 'Nº de serie de tu cédula de identidad',
			defaultValue: '',
			name: FORM.SERIAL_NUMBER_ID,
			type: LAYOUT_ITEM.TYPE.INPUT,
			placeholder: 'Ej: 181291873 o A123456789',
			dropText: <InfoSerialNumber />,
			validation: yup
				.string()
				.required('Campo Requerido')
				.min(9, 'ingrese un Nº de serie válido')
				.max(10, 'ingrese un Nº de serie válido')
				.matches(/^[a-zA-Z0-9]+$/, 'Ingrese solo números y letras, sin puntos')
		},
		{
			label: 'Fecha de ingreso laboral',
			defaultValue: dateOfEmployment ? dateOfEmployment : '',
			name: FORM.DATE_OF_EMPLOYMENT,
			type: LAYOUT_ITEM.TYPE.INPUT,
			mask: '##/####',
			placeholder: 'Ej: 04/2020',
			validation: yup
				.string()
				.required('Campo Requerido')
				.length(6, 'Ingrese una fecha válida')
				.matches(/^[0-9]+$/, 'Ingrese solo números')
				.test('date-limit-valid', 'Ingrese una fecha válida', (value) => {
					return value !== undefined ? DateStringValidator(value) : false;
				}),
		},
		{
			label: 'Sueldo líquido',
			defaultValue: salary ? salary : '',
			name: FORM.SALARY,
			type: LAYOUT_ITEM.TYPE.INPUT,
			prefix: '$',
			mask: 'money',
			tooltip: 'Suma de dinero que recibes como sueldo a fin de mes.',
			placeholder: ' Ej: 900.000',
			validation: yup
				.number()
				.required('Campo Requerido')
				.typeError('Campo Requerido')
				.min(600000, 'Sueldo  mínimo $600.000'),
		},
	];

	useEffect(
		() => {
			TagManager.dataLayer({
				dataLayer: DATA_LAYERS.get(DATA_LAYER_PAGE.PAGE_PORTABILITY_MULTI_FORM_6_STEP_3),
			});
			storageService.deleteByKey(IDENTITY_STORAGE, sessionStorage);
		},
		//eslint-disable-next-line
		[]
	);

	return (
		<div>
			<MultiFormCardHeader
				title="Información personal"
				body="Ahora necesitamos algunos datos para validar
            tu identidad y generar una mejor oferta"
			/>

			<CreateFormLayout key={fields.length} fields={fields} />
		</div>
	);
};
